export type DeviceType = 'desktop' | 'mobile_app' | 'mobile_view';

export type UserRole = 'customer' | 'community' | 'owner' | 'staff' | 'superadmin';

export interface AppLoginRequest {
  identifier: string;
  password: string;
  device_type?: DeviceType;
  device_id?: string;
}

export interface CommunityUserProfile {
  name: string;
  email: string;
  avatar?: string;
  phone?: string;
  nickname: string;
  is_verified: boolean;
}

export interface AppAuthResponse {
  token: string;
  refresh_token?: string;
  exp: number;
  role: UserRole;
  user_id: number;
  email: string;
  username: string;
  name: string;
  avatar?: string;
  slug?: string;
  arena?: string;
  mitra_name?: string;
  client_name?: string;
  community_user?: CommunityUserProfile;
  is_verified?: boolean;
  login_with_credentials?: boolean;
  acting_as?: 'co_host';
  managed_community_id?: number;
}

export interface AppMeResponse {
  user_id: number;
  role: UserRole;
  email: string;
  username: string;
  name: string;
  avatar?: string;
  slug?: string;
  arena?: string;
  community_user?: CommunityUserProfile;
  is_verified?: boolean;
  acting_as?: 'co_host';
  managed_community_id?: number;
}

export function isCoHostUser(
  user: Pick<AppMeResponse, 'acting_as'> | Pick<AppAuthResponse, 'acting_as'> | null | undefined
): boolean {
  return user?.acting_as === 'co_host';
}

export interface RefreshRequest {
  refresh_token?: string;
  device_id?: string;
}
